/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventIpCountResponse
 */
export interface AuditEventIpCountResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditEventIpCountResponse
     */
    ip?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventIpCountResponse
     */
    count?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventIpCountResponse
     */
    failedCount?: any | null;
}

/**
 * Check if a given object implements the AuditEventIpCountResponse interface.
 */
export function instanceOfAuditEventIpCountResponse(value: object): value is AuditEventIpCountResponse {
    return true;
}

export function AuditEventIpCountResponseFromJSON(json: any): AuditEventIpCountResponse {
    return AuditEventIpCountResponseFromJSONTyped(json, false);
}

export function AuditEventIpCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventIpCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ip': json['ip'] === undefined ? undefined : json['ip'] === null ? null : json['ip'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
        'failedCount': json['failedCount'] === undefined ? undefined : json['failedCount'] === null ? null : json['failedCount'],
    };
}

export function AuditEventIpCountResponseToJSON(json: any): AuditEventIpCountResponse {
    return AuditEventIpCountResponseToJSONTyped(json, false);
}

export function AuditEventIpCountResponseToJSONTyped(value?: AuditEventIpCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ip': value['ip'],
        'count': value['count'],
        'failedCount': value['failedCount'],
    };
}

